<template>
    <!-- ======= 1.04 Service Area ====== -->
    <div class="serviceArea secPdng animated">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="sectionTitle">
                        <div class="h2">Num mercado de cheio de opções. <br>Porque nos <span>escolheria?</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row service">
                <div class="row">
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/gear.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Integrações prontas</span>
                                <p>Fornecemos integrações com as mais populares plataformas de e-commerce e
                                    pontos-de-venda e integrações pronto-para-usar em diversas
                                    linguagens de programação</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/cloud-up.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Alta disponibilidade</span>
                                <p>Acompanhe as suas transações através dos nossos canais de notificação(email, sms,
                                    push) em uma plataforma com alta disponibilidade.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/care-support.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Corpo de suporte 24/7</span>
                                <p>Temos um corpo de suporte disponivel para ajudar em suas dúvidas e questões
                                    técnicas.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/serv-04.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Soluções inteligentes</span>
                                <p>Providencie aos seus clientes diversas formas de fazer pagamentos como QRCodes,
                                    Email,
                                    USSD, pagamentos recorrentes automáticos.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/serv-05.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Segurança</span>
                                <p>Temos um sério compromisso com a sua segurança por isso todos os dados são
                                    encriptados e
                                    implementamos as mais recentes práticas de segurança no ramo.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4">
                        <div class="singleService">
                            <div class="serviceIcon">
                                <img src="../../assets/images/icon/serv-06.png" alt="">
                            </div>
                            <div class="serviceContent">
                                <span class="h3">Chat de suporte Chat </span>
                                <p>Tenha acesso a suporte através da nossa plataforma de chat em tempo real para
                                    qualquer
                                    questões que tiver 24/7</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <!-- ======= /1.04 Service Area ====== -->
</template>

<script>
  export default {
    name: 'site-advantages'
  }
</script>

<style scoped>
    .serviceArea {
        background-color: #f0f5fa;
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SiteAdvantages.vue